const STATUS_BADGE_MAP = {
  pending: 'bg-warning-subtle text-warning',
  active: 'bg-success-subtle text-success',
  suspended: 'bg-danger-subtle text-danger',
  terminated: 'bg-secondary-subtle text-secondary',
};

export function getPartnerStatusBadgeClass(status) {
  const normalized = String(status || '').trim().toLowerCase();
  return STATUS_BADGE_MAP[normalized] || 'bg-secondary-subtle text-secondary';
}
